
<template>
  <div class="modal" :class="{ 'is-active': true }">
    <div class="modal-background" @click.stop="$emit('close')"></div>
    <div class="modal-content">
      <div class="box modal-container" style="overflow: hidden">
        <div class="modal-content-root" @click.stop="() => {}">
          <div class="title-font is-size-4 mainColor--text">
            Move keyword{{ selectedSiloKeywords?.length > 1 ? 's':'' }} to another Silo
          </div>
          <div class="mt-10 mb-10">
            <template
              v-if="!showCreateSiloView"
            >
              <v-autocomplete
                class="mb-4"
                outlined dense hide-details
                placeholder="Select a silo"
                color="grayColor"
                item-text="name"
                item-value="id"
                :disabled="loading"
                :items="silos.filter(s => s.id !== silo.id)"
                v-model="selectedSiloId"
              >
              </v-autocomplete>
              
              <v-btn
                rounded
                outlined
                color="mainColor"
                class="text-none"
                @click="showCreateSiloView = true"
              >
                or Create a new silo
              </v-btn>
            </template>
            <template v-else>
              <v-text-field
                v-model="newSiloName"
                outlined
                dense
                hide-details
                label="Type your new silo's name"
                placeholder="Type your new silo's name"
                color="grayColor"
              ></v-text-field>
            </template>
          </div>
          <div class="flex mt20 justify-space-between">
            <template v-if="!showCreateSiloView">
              <v-btn rounded outlined color="mainColor" class="button-with-icon mainColor--text text-none"
                @click.stop="$emit('close')">
                <span>Cancel</span>
              </v-btn>
              <v-btn rounded color="profileAnchorColor" class="button-with-icon text-none whiteColor--text"
                :disabled="!selectedSiloId || loading"
                @click.stop="submit">
                <span>Move</span>
              </v-btn>
            </template>
            <template v-else>
              <v-btn rounded outlined color="mainColor" class="button-with-icon mainColor--text text-none"
                @click.stop="showCreateSiloView = false">
                <span>Go back</span>
              </v-btn>
              <v-btn rounded color="profileAnchorColor" class="button-with-icon text-none whiteColor--text"
                :disabled="!newSiloName|| loading"
                @click.stop="createSiloAndSubmit">
                <span>Create silo and move keyword{{ selectedSiloKeywords?.length > 1 ? 's':'' }}</span>
              </v-btn>
            </template>
          </div>
        </div>
      </div>
      <button class="custom-modal-close-btn" aria-label="close" @click.stop="$emit('close')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['silo', 'selectedSiloKeywords'],
  data() {
    return {
      silos: [],
      selectedSiloId: null,
      loading: true,
      showCreateSiloView: false,
      newSiloName: '',
    };
  },
  methods: {
    getSilos (silent = false) {
      if (!silent) {
        this.loading = true
      }
      // the dropdown only renders silo id + name
      return this.$store.dispatch('getSilos', {
        campaignId: this.silo.campaignId,
        includeKeywords: 0,
        includeAiAndPageRunResult: 0,
        includeContentReportOrder: 0,
        includePage: 0,
      })
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            this.silos = response.data.data
          }
        })
        .finally(() => {
          if (!silent) {
            this.loading = false
          }
        })
    },
    createSiloAndSubmit() {
      this.$store.commit('showLoading');
      return this.$store.dispatch('createSilo', { campaignId: this.silo.campaignId, name: this.newSiloName })
        .then((response) => {
          if (response.data && response.data.status === 'SUCCESS') {
            return this.moveToSilo(response.data.data.id)
          } else if (response.data && response.data.status === 'FAILURE') {
            this.$notify({
              group: 'info', type: 'error',
              text: response.data.msg || 'Could not create silo'
            })
            return Promise.reject()
          }
        })
        .then(() => this.getSilos(true))
        .then(() => {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Keywords moved successfully.'
          })
          this.$emit('success');
          this.$emit('close');
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    },
    moveToSilo(siloId) {
      return this.$store
        .dispatch('moveSiloKeywords', {
          siloId: siloId,
          body: { selectedSiloKeywords: this.selectedSiloKeywords },
        })
        .then((response) => {
          if (response.data && response.data.status === 'FAILURE') {
            this.$notify({
              group: 'info', type: 'error',
              text: response.data.msg || 'An error happened'
            })
            return Promise.reject()
          }
        })
    },
    submit() {
      this.$store.commit('showLoading');
      return this.moveToSilo(this.selectedSiloId)
        .then(() => {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Keywords moved successfully.'
          })
          this.$emit('success');
          this.$emit('close');
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        });
    }
  },
  mounted() {
    this.getSilos()
  }
};

</script>

